import { IIconProps } from 'src/interfaces/IconProps';

const ArrowBackIcon = ({ width = 15, height = 20, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      // eslint-disable-next-line max-len
      d='M7.85355 0.146447C8.04881 0.341709 8.04881 0.658291 7.85355 0.853553L1.70711 7H15.5C15.7761 7 16 7.22386 16 7.5C16 7.77614 15.7761 8 15.5 8H1.70711L7.85355 14.1464C8.04882 14.3417 8.04882 14.6583 7.85355 14.8536C7.65829 15.0488 7.34171 15.0488 7.14645 14.8536L0.146447 7.85355C0.0526784 7.75979 0 7.63261 0 7.5C0 7.36739 0.0526784 7.24022 0.146447 7.14645L7.14645 0.146447C7.34171 -0.0488155 7.65829 -0.0488155 7.85355 0.146447Z'
      fill={color}
    />
  </svg>
);

export default ArrowBackIcon;
